import { render } from "./JobDescription.vue?vue&type=template&id=e2330d5e"
import script from "./JobDescription.vue?vue&type=script&lang=js"
export * from "./JobDescription.vue?vue&type=script&lang=js"

import "./JobDescription.vue?vue&type=style&index=0&id=e2330d5e&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__